<script lang="ts">
    import CardWrapper from "../CardWrapper.svelte"
    import { login } from "../../../../store"
    import {
        addCustomerAddress,
        deleteCustomerAddress,
        getCustomerAddresses,
        updateCustomerAddress,
    } from "../../../../functions/CommerceAPIs/bigCommerce/customer"
    import Address from "./Address.svelte"
    import AddressForm from "../AddressForm.svelte"
    import Icon from "../../../widgets/Icon.svelte"
    import { mdiPlusCircleOutline } from "@mdi/js"
    import { createEmptyAddress, removeAllErrors, validateAddress } from "../helper"

    export let customer: BigCommerceCustomer
    async function updateAddress(editedAddress: BigCommerceAddress, addresses: BigCommerceAddress[]) {
        if (editedAddress.id) {
            await updateCustomerAddress($login.tokenData.tibiId, editedAddress).then((updatedAddress) => {
                const index = addresses.findIndex((a) => a.id === updatedAddress.id)
                addresses[index] = updatedAddress
            })
        } else {
            await addCustomerAddress($login.tokenData.tibiId, editedAddress).then((newAddress) => {
                addresses.push(newAddress)
            })
        }
    }
    let editedAddress: BigCommerceAddress = undefined
    let form: HTMLFormElement
    let rerender = 0
</script>

<div class="wrapper">
    <CardWrapper>
        <h3>
            {editedAddress
                ? !editedAddress.id
                    ? "Adresse hinzufügen"
                    : "Adresse bearbeiten"
                : "Gespeicherte Adressen"}
        </h3>
        {#await getCustomerAddresses($login.tokenData.tibiId)}
            <p>Adressen werden geladen...</p>
        {:then addresses}
            {#if editedAddress}
                <form bind:this="{form}">
                    <div class="address">
                        <AddressForm bind:address="{editedAddress}" />
                    </div>
                    <div class="action-button-line">
                        <button
                            class="cta primary"
                            on:click|stopPropagation|preventDefault="{() => {
                                editedAddress = undefined
                                removeAllErrors(form)
                            }}">{editedAddress.id ? "Änderungen" : "Adresse"} verwerfen</button
                        >
                        <button
                            class="cta secondary"
                            on:click|stopPropagation|preventDefault="{() => {
                                const isValid = validateAddress(editedAddress)
                                if (isValid)
                                    updateAddress(editedAddress, addresses).then(() => (editedAddress = undefined))
                            }}">{editedAddress.id ? "Änderungen" : "Adresse"} speichern</button
                        >
                    </div>
                </form>
            {:else}
                <ul>
                    {#key rerender}
                        {#each addresses as address}
                            {#if address}
                                <Address
                                    address="{address}"
                                    on:edit="{() => {
                                        editedAddress = JSON.parse(JSON.stringify(address))
                                    }}"
                                    on:delete="{() => {
                                        deleteCustomerAddress($login.tokenData.tibiId, address.id).then(() => {
                                            let addressIndex = addresses.findIndex((a) => a.id === address.id)
                                            addresses.splice(addressIndex, 1)
                                            rerender += 1
                                        })
                                    }}"
                                />
                            {/if}
                        {/each}{/key}
                </ul>
                <button
                    class="action-line"
                    on:click|stopPropagation|preventDefault="{() => {
                        editedAddress = createEmptyAddress()
                    }}"
                >
                    <p>Neue Adresse hinzufügen</p>
                    <span><Icon path="{mdiPlusCircleOutline}" /> </span>
                </button>
            {/if}
        {/await}
    </CardWrapper>
</div>

<style lang="less">
    .wrapper {
        display: flex;
        width: 100%;
        flex-grow: 1;
        h3 {
            padding: 0px 2.4rem;
            color: var(--text-invers-100);
        }
        form {
            .address {
                padding: 0px 2.4rem;
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: 1.2rem;
            }

            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 2.4rem;
        }
        ul {
            display: grid;
            grid-template-columns: 1fr 1fr;
            padding: 0px 2.4rem;
            gap: 24px;
        }
        .action-button-line,
        .action-line {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }
        .action-line {
            background: var(--bg-100);
            padding: 0.6rem 3.3rem 0.6rem 3.3rem;
            display: flex;
            flex-direction: row;
            align-items: center;
            height: 48px;
            justify-content: space-between;
            p,
            span {
                color: var(--neutral-white);
            }
        }

        .action-button-line {
            height: 48px;
            display: flex;
            width: 100%;
            button {
                width: 0px;
                height: 100%;
                flex-grow: 1;
            }
        }
    }
</style>
